<template>
  <div>
    <el-button type="primary" icon="el-icon-view" @click="dialogVisible = true"
      >查看币种周期</el-button
    >
    <el-dialog
      :visible="dialogVisible"
      title="新增抵押周期设置"
      width="1200px"
      @open="serchList"
      @close="dialogVisible = false"
    >
    
      <el-table :data="CycleList">
      <el-table-column label="时间">
        <template slot-scope="scope">{{
          scope.row.createTime | moment
        }}</template>
      </el-table-column>
      <el-table-column
        prop="borrowCoinType"
        label="借币种类型"
      ></el-table-column>
      <el-table-column prop="defaultRate" label="违约利率"></el-table-column>
      <el-table-column prop="overdueRate" label="逾期利率"></el-table-column>
      <el-table-column prop="numberDays" label="周期"></el-table-column>
      <el-table-column label="利率" prop="yearRate"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-tooltip content="修改">
            <el-button
              type="primary"
              size="small"
              circle
              icon="el-icon-edit"
              @click="edit(scope.row)"
            ></el-button>
          </el-tooltip>
          <el-tooltip content="删除">
            <el-button
              type="danger"
              size="small"
              circle
              icon="el-icon-delete"
              @click="removeList(scope.row)"
            ></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
      </span>
    </el-dialog>
    <detail @refresh="handleCurrentChange()"></detail>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import Detail from '../cycleDetail';

export default {
  name: 'cycleList',
  data(){
      return{
          dialogVisible:false,
          CycleList:[]
      }
  },
  computed: {
  },
  components: {
    Detail
  },
  methods: {
    ...mapActions('mortgage', ['removeCycle', 'getCycleList']),
    ...mapMutations('mortgage', ['setchangeCycle']),
    edit(project) {
      this.setchangeCycle(project);
    },
    handleCurrentChange(pagination) {
      this.$emit('refresh', pagination);
    },
    serchList(){
        this.getCycleList().then(res=>{
          this.CycleList = res.data;
        });
    },
    removeList(row) {
      this.$confirm('确认要进行此操作吗？', '提示', { type: 'warning' }).then(
        () => {
          this.removeCycle({
            borrowCoinType: row.borrowCoinType,
            numberDays: row.numberDays
          }).then(() => {
            this.$message.success('删除成功！');
            this.getList();
          });
        }
      );
    }
  }
};
</script>

<style lang="less"></style>
